'use strict';

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  PrismProductOutOfStockWarning
// -----------------------------------------------------------
const PrismProductOutOfStockWarning = () => {
  const message = typeof App !== 'undefined' && App.order.logged_in()
    ? 'Sorry, this product is out of stock.  Select a different delivery option or save for later to proceed.'
    : 'Sorry, this product is out of stock.  Select a different delivery option to proceed.';

  return (
    <div className="alert alert-danger" role="alert">
      {message}
    </div>
  );
};

PrismProductOutOfStockWarning.displayName = 'PrismProductOutOfStockWarning';

export default PrismProductOutOfStockWarning;
